module.exports = __webpack_public_path__ + "4febc1c74b7b2c8f6d5ba25fbb7f6477.svg";